<template>
  <div class="filtro-busca-telas-campos">
    <template v-for="(filtro, indexF) in cpntField">
      <template v-if="[ '', null, undefined ].indexOf(filtro.id) === -1">
        <RF-Select2 :key="indexF" v-if='filtro.tipo === "select2"' :data-time="indexF + '-' + cpntTime + '-' + time" :class="'rf-filtro-tela-' + indexF"
          :cpntStatus='filtro.status'
          :cpntId='filtro.id'
          :cpntClassDivField='filtro.classDivField'
          :cpntNome='filtro.nome'
          :cpntValue='filtro.value'
          :cpntOptions='filtro.options'
          :cpntKeyValue='filtro.keyValue'
          :cpntKeyMostra='filtro.keyMostra'
          :cpntAutoComplete='filtro.autocomplete'
          :cpntDisabled='filtro.disabled'
          :cpntMostrar='filtro.mostrar'
          :cpntSearchMinimo='filtro.searchMinimo'
          :cpntMensagem='filtro.mensagem'
          :cpntOptionInicialNome='filtro.optionInicialNome'
          :cpntOptionInicialValue='filtro.optionInicialValue'
          :cpntMensagemTipo='filtro.mensagemTipo'
          :cpntAddOption='filtro.addOption'
          :cpntMultiple='filtro.multiple'
          :cpntExplica='filtro.explica'

          :cpntOnChange='filtro.onChange'
          :ref='indexF'
        ></RF-Select2>

        <RF-Select2-Chosen :key="indexF" v-if='filtro.tipo === "select2-chosen"' :data-time="indexF + '-' + cpntTime + '-' + time" :class="'rf-filtro-tela-' + indexF"
          :cpntStatus='filtro.status'
          :cpntId='filtro.id'
          :cpntClassDivField='filtro.classDivField'
          :cpntNome='filtro.nome'
          :cpntPosicaoNome='filtro.posicaoNome'
          :cpntValue='filtro.value'
          :cpntOptions='filtro.options'
          :cpntKeyValue='filtro.keyValue'
          :cpntKeyMostra='filtro.keyMostra'
          :cpntAutoComplete='filtro.autocomplete'
          :cpntDisabled='filtro.disabled'
          :cpntMostrar='filtro.mostrar'
          :cpntMensagem='filtro.mensagem'
          :cpntSelecioneNome='filtro.selecioneNome'
          :cpntSelecioneValue='filtro.selecioneValue'
          :cpntMensagemTipo='filtro.mensagemTipo'
          :cpntAdicinarOption='filtro.adicinarOption'
          :cpntMultiple='filtro.multiple'
          :cpntAllRegistro='filtro.allRegistro'
          :cpntExplica='filtro.explica'
          :cpntTabIndex='filtro.tabIndex'

          :cpntOnChange='filtro.onChange'
          :cpntOnBlur='filtro.onBlur'
          :ref='filtro.tipo'
        ></RF-Select2-Chosen>

        <div :key="indexF" v-else-if='filtro.tipo === "data"' :data-time="indexF + '-' + cpntTime + '-' + time" :class="'filtro-data-tela rf-filtro-tela-' + indexF" v-show="cpntField[indexF].mostrar">
          <table v-if="[ '', null, undefined ].indexOf(formulario) === -1 && [ '', null, undefined ].indexOf(formulario.field) === -1">
            <tr>
              <td v-if="[ '', null, undefined ].indexOf(formulario.field[indexF + '__seletor']) === -1">
                <RF-Select2 :data-time="indexF + '__seletor-' + cpntTime + '-' + time"
                  :cpntStatus='formulario.field[indexF + "__seletor"].status'
                  :cpntId='formulario.field[indexF + "__seletor"].id'
                  :cpntClassDivField='formulario.field[indexF + "__seletor"].classDivField'
                  :cpntNome='cpntField[indexF].nome'
                  :cpntValue='formulario.field[indexF + "__seletor"].value'
                  :cpntOptions='formulario.field[indexF + "__seletor"].options'
                  :cpntKeyValue='formulario.field[indexF + "__seletor"].keyValue'
                  :cpntKeyMostra='formulario.field[indexF + "__seletor"].keyMostra'
                  :cpntAutoComplete='formulario.field[indexF + "__seletor"].autocomplete'
                  :cpntDisabled='formulario.field[indexF + "__seletor"].disabled'
                  :cpntMostrar='formulario.field[indexF + "__seletor"].mostrar'
                  :cpntSearchMinimo='formulario.field[indexF + "__seletor"].searchMinimo'
                  :cpntMensagem='formulario.field[indexF + "__seletor"].mensagem'
                  :cpntOptionInicialNome='formulario.field[indexF + "__seletor"].optionInicialNome'
                  :cpntOptionInicialValue='formulario.field[indexF + "__seletor"].optionInicialValue'
                  :cpntMensagemTipo='formulario.field[indexF + "__seletor"].mensagemTipo'
                  :cpntAddOption='formulario.field[indexF + "__seletor"].addOption'
                  :cpntMultiple='formulario.field[indexF + "__seletor"].multiple'
                  :cpntExplica='formulario.field[indexF + "__seletor"].explica'

                  :cpntOnChange='formulario.field[indexF + "__seletor"].onChange'
                  :ref='indexF + "__seletor"'
                ></RF-Select2>
              </td>

              <td v-if="[ '', null, undefined ].indexOf(formulario.field[indexF + '__data_ini']) === -1 && formulario.field[indexF + '__data_ini'].mostrar === true">
                <RF-Input-Calendario :data-time="indexF + '__data_ini-' + cpntTime + '-' + time"
                  :cpntStatus='formulario.field[indexF + "__data_ini"].status'
                  :cpntId='formulario.field[indexF + "__data_ini"].id'
                  :cpntClassDivField='formulario.field[indexF + "__data_ini"].classDivField'
                  :cpntNome='formulario.field[indexF + "__data_ini"].nome'
                  :cpntValue='formulario.field[indexF + "__data_ini"].value'
                  :cpntOptions='formulario.field[indexF + "__data_ini"].options'
                  :cpntKeyValue='formulario.field[indexF + "__data_ini"].keyValue'
                  :cpntKeyMostra='formulario.field[indexF + "__data_ini"].keyMostra'
                  :cpntAutoComplete='formulario.field[indexF + "__data_ini"].autocomplete'
                  :cpntDisabled='formulario.field[indexF + "__data_ini"].disabled'
                  :cpntMostrar='formulario.field[indexF + "__data_ini"].mostrar'
                  :cpntMensagem='formulario.field[indexF + "__data_ini"].mensagem'
                  :cpntOptionInicialNome='formulario.field[indexF + "__data_ini"].optionInicialNome'
                  :cpntOptionInicialValue='formulario.field[indexF + "__data_ini"].optionInicialValue'
                  :cpntMensagemTipo='formulario.field[indexF + "__data_ini"].mensagemTipo'
                  :cpntAddOption='formulario.field[indexF + "__data_ini"].addOption'
                  :cpntMultiple='formulario.field[indexF + "__data_ini"].multiple'
                  :cpntExplica='formulario.field[indexF + "__data_ini"].explica'
                  :cpntPosicionar='formulario.field[indexF + "__data_ini"].posicionar'

                  :cpntOnChange='formulario.field[indexF + "__data_ini"].onChange'
                  :ref='indexF + "__data_ini"'
                ></RF-Input-Calendario>
              </td>

              <td v-if="[ '', null, undefined ].indexOf(formulario.field[indexF + '__data_fim']) === -1 && formulario.field[indexF + '__data_fim'].mostrar === true">
                <RF-Input-Calendario :data-time="indexF + '__data_fim-' + cpntTime + '-' + time"
                  :cpntStatus='formulario.field[indexF + "__data_fim"].status'
                  :cpntId='formulario.field[indexF + "__data_fim"].id'
                  :cpntClassDivField='formulario.field[indexF + "__data_fim"].classDivField'
                  :cpntNome='formulario.field[indexF + "__data_fim"].nome'
                  :cpntValue='formulario.field[indexF + "__data_fim"].value'
                  :cpntOptions='formulario.field[indexF + "__data_fim"].options'
                  :cpntKeyValue='formulario.field[indexF + "__data_fim"].keyValue'
                  :cpntKeyMostra='formulario.field[indexF + "__data_fim"].keyMostra'
                  :cpntAutoComplete='formulario.field[indexF + "__data_fim"].autocomplete'
                  :cpntDisabled='formulario.field[indexF + "__data_fim"].disabled'
                  :cpntMostrar='formulario.field[indexF + "__data_fim"].mostrar'
                  :cpntMensagem='formulario.field[indexF + "__data_fim"].mensagem'
                  :cpntOptionInicialNome='formulario.field[indexF + "__data_fim"].optionInicialNome'
                  :cpntOptionInicialValue='formulario.field[indexF + "__data_fim"].optionInicialValue'
                  :cpntMensagemTipo='formulario.field[indexF + "__data_fim"].mensagemTipo'
                  :cpntAddOption='formulario.field[indexF + "__data_fim"].addOption'
                  :cpntMultiple='formulario.field[indexF + "__data_fim"].multiple'
                  :cpntExplica='formulario.field[indexF + "__data_fim"].explica'
                  :cpntPosicionar='formulario.field[indexF + "__data_fim"].posicionar'

                  :cpntOnChange='formulario.field[indexF + "__data_fim"].onChange'
                  :ref='indexF + "__data_fim"'
                ></RF-Input-Calendario>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </template>
  </div>
</template>

<style scoped>
.filtro-busca-telas-campos {
  padding-top: 20px;
  text-align: left;
}
  .filtro-busca-telas-campos > div {
    display: block;
    width: 100%;
    text-align: center;
  }
  .filtro-busca-telas-campos > .filtro-data-tela > table {
    width: 100%;
  }
    .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:first-child,
    .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:first-child > div {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
    .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:not(:first-child),
    .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:not(:first-child) > div {
      width: 115px;
      min-width: 115px;
      max-width: 115px;
      padding: 0px 4px;
    }
</style>

<style>
  .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:not(:first-child) > div > input {
    border: 1px solid #ccc !important;
    text-align: center !important;
    padding: 4px 0px !important;
    height: initial !important;
    border-radius: 5px !important;
    background: #fff !important;
  }
  .filtro-busca-telas-campos > .filtro-data-tela > table > tr > td:not(:first-child) > div > input ~ label {
    margin-left: 5px;
    margin-top: 3px;
  }

  .filtro-busca-telas-campos > .rf-select2-chosen-fechado > div > button {
    width: 100%;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'fil-bus-tel_' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntTime: {
        required: true
      },
      cpntField: {
        required: true,
        type: Object
      }
    },
    components: {
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue'),
      'RF-Select2-Chosen': () => import('@/components/rf-geral/select2-chosen/RF-Select2-Chosen.vue'),
      'RF-Input-Calendario': () => import('@/components/rf-geral/input-calendario/RF-Input-Calendario.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        formulario: {}
      }
    },
    mounted: function () {
      this.filtroBuscaTelaCamposIniciar()
    },
    methods: {
      filtroBuscaTelaCamposIniciar: function () {
        // PEGA A DATA ATUAL
        if ([ '', null, undefined ].indexOf(this.$store.state.token) === -1 && Object.keys(this.$store.state.token).length >= 1) {
          var dataAtual = moment(this.$store.state.dadosApi.dataAtual.split(' ')[0], 'DD/MM/YYYY')
        }

        // SETA OS DADOS DO FORMULARIO
        this.formulario = { id: this.cpntHashId, field: {} }

        // TRATA OS CAMPOS SOLICITADOS
        for (var indexF in this.cpntField) {
          // VERIFICA SE É DO TIPO DATA O FILTRO
          if (this.cpntField[indexF].tipo === 'data') {
            this.formulario.field[indexF + '__seletor'] = {
              id: this.cpntHashId + '--' + indexF + '__seletor',
              status: '',
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              optionInicialNome: 'Todos',
              searchMinimo: 15,
              options: [
                { id: '1', nome: 'Hoje (' + dataAtual.format('DD/MM/YYYY') + ')' },
                { id: '2', nome: 'Ontem (' + dataAtual.subtract('1', 'day').format('DD/MM/YYYY') + ')' },
                { id: '3', nome: 'Mês atual' },
                { id: '4', nome: 'Mês anterior' },
                { id: '5', nome: 'Próximo mês' },
                { id: '6', nome: 'Ano atual' },
                { id: '7', nome: 'Ano anterior' },
                { id: '8', nome: 'Personalizado' }
              ],
              value: [ '', null, undefined ].indexOf(this.cpntField[indexF].value) !== -1 ? '' : this.cpntField[indexF].value,
              onChange: this.filtroBuscaTelaCamposOnChange
            }
            this.formulario.field[indexF + '__data_ini'] = {
              id: this.cpntHashId + '--' + indexF + '__data_ini',
              status: '',
              nome: 'De',
              posicionar: true,
              value: [ '', null, undefined ].indexOf(this.cpntField[indexF].dataIni) !== -1 ? '' : this.cpntField[indexF].dataIni,
              onChange: this.filtroBuscaTelaCamposOnChange
            }
            this.formulario.field[indexF + '__data_fim'] = {
              id: this.cpntHashId + '--' + indexF + '__data_fim',
              status: '',
              nome: 'Até',
              posicionar: true,
              value: [ '', null, undefined ].indexOf(this.cpntField[indexF].dataFim) !== -1 ? '' : this.cpntField[indexF].dataFim,
              onChange: this.filtroBuscaTelaCamposOnChange
            }

            // CHAMA AFUNÇÃO PARA FORMATAR OS VALORES DOS CAMPOS
            this.proFormularioPrincipalVerificarCampos(indexF + '__seletor')
          }
        }
      },
      filtroBuscaTelaCamposSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      filtroBuscaTelaCamposOnChange: function (value, id) {
        // PEGA OS DADOS DO CAMPO QUE SERÁ ATUALIZADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO QUE DEVE FAZER EM CADA CAMPO
        switch (index) {
          case 'data__seletor':
            this.filtroBuscaTelaCamposMontarDataInicioFim(index.replace('__seletor', ''), () => { this.proFormularioPrincipalVerificarCampos(index) })
            break

          case 'data__data_fim':
          case 'data__data_ini':
            this.filtroBuscaTelaCamposRealizarOnChange('data')
            break
        }
      },
      filtroBuscaTelaCamposMontarDataInicioFim: function (chave, callback = null) {
        // PEGA A DATA ATUAL
        var dataAtual = this.$store.state.dadosApi.dataAtual

        // NOVA DATA 
        var dataIni = ''
        var dataFim = ''

        // TRATA O VALOR PARA CADA TIPO DE SELEÇAO
        switch (this.formulario.field[chave + '__seletor'].value) {
          case '':
            break
          
          case '1':
            dataIni = moment(dataAtual, 'DD/MM/YYYY')
            dataFim = moment(dataAtual, 'DD/MM/YYYY')
            break

          case '2':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'd')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'd')
            break

          case '3':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').startOf('M')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').endOf('M')
            break

          case '4':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'M').startOf('M')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'M').endOf('M')
            break

          case '5':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').add('1', 'M').startOf('M')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').add('1', 'M').endOf('M')
            break

          case '6':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').startOf('Y')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').endOf('Y')
            break

          case '7':
            dataIni = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'Y').startOf('Y')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').subtract('1', 'Y').endOf('Y')
            break

          case '8':
            // CALCULA O VALOR DO CAMPO
            dataIni = moment(dataAtual, 'DD/MM/YYYY').startOf('M')
            dataFim = moment(dataAtual, 'DD/MM/YYYY').endOf('M')

            // REALIZA O FOCUS NO CAMPO SOLICITADO
            this.filtroBuscaTelaCamposFocusCampo(chave + '__data_ini')
            break
        }

        // SETA OS VALORES NO FORMULARIO
        this.formulario.field[chave + '__data_ini'].value = [ '', null, undefined ].indexOf(dataIni) !== -1 ? '' : dataIni.format('DD/MM/YYYY')
        this.formulario.field[chave + '__data_fim'].value = [ '', null, undefined ].indexOf(dataFim) !== -1 ? '' : dataFim.format('DD/MM/YYYY')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA REALIZAR ONCHANGE
        this.filtroBuscaTelaCamposRealizarOnChange(chave)

        // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      proFormularioPrincipalVerificarCampos: function (campos, index = 0, callback = null) {
        if (campos === 'todos') {
          // PEGA TODOS OS CAMPOS SOLICITADOS
          campos = Object.keys(this.formulario.field)

          // REMOVE O VALOR PARA NÃO ENTRAR EM UM LOOP NO CALCULO DE MARKUP
          campos = campos.filter(item => [].indexOf(item) === -1)
        } else if (typeof campos === 'string') {
          campos = [ campos ]
        }

        // REMOVER VALORES DUPLICADOS
        campos = campos.filter((v, i, a) => v.indexOf('separador-') === -1 && a.indexOf(v) === i)

        if ([ '', null, undefined ].indexOf(campos[index]) === -1) {
          // PEGA A CHAVE ENCONTRADA
          var chave = campos[index]

          // SETA A FUNÇÃO PARA REINICIAR O PROCESSO
          var restart = () => { this.proFormularioPrincipalVerificarCampos(campos, (index + 1), callback) }

          // VERIFICA A AÇÃO DE CADA CAMPO
          switch (chave) {
            case 'data__seletor':
              // ADICIONA OS CAMPOS QUE DEVE PROCESSAR
              campos = campos.concat([ 'data__data_fim', 'data__data_ini' ])

              // REINICIA O PROCESSO
              restart()
              break

            case 'data__data_fim':
            case 'data__data_ini':
              // VERIFICA SE DEVE MOSTRAR O CAMPO
              this.formulario.field[chave].mostrar = this.formulario.field.data__seletor.value === '8'

              // REINICIA O PROCESSO
              restart()
              break

            default:
              // REINICIA O PROCESSO
              restart()
              break
          }
        } else {
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null) {
            callback()
          }
        }
      },
      filtroBuscaTelaCamposRealizarOnChange: function (chave) {
        if ([ '', null, undefined ].indexOf(this.cpntField[chave].onChange) === -1) {
          // SETA O VALOR DO CAMPO
          var value = {
            ini: this.formulario.field[chave + '__data_ini'].value,
            fim: this.formulario.field[chave + '__data_fim'].value,
            seletor: this.formulario.field[chave + '__seletor'].value
          }
  
          // CHAMA A FUNÇÃO ONCHANGE PARA ATUALIZARO VALOR NO COMPONENT PAI
          this.cpntField[chave].onChange(value, this.cpntField[chave].id)
        }
      },
      filtroBuscaTelaCamposFocusCampo: function (chave, tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1) {
            // PEGA O CAMPO QUE DEVE REALIZAR A ATUALIZAÇÃO
            var campo = this.$refs[chave].length === 1 ? this.$refs[chave][0] : this.$refs[chave]

            // VERIFICA SE O CAMPO FOI ENCONTRADO
            if ([ '', null, undefined ].indexOf(campo) === -1 && [ '', null, undefined ].indexOf(campo.onFocusField) === -1) {
              setTimeout(() => { campo.onFocusField() }, 200)
            } else {
              setTimeout(() => { this.filtroBuscaTelaCamposFocusCampo(chave, (tentativa + 1)) }, 200)
            }
          } else {
            setTimeout(() => { this.filtroBuscaTelaCamposFocusCampo(chave, (tentativa + 1)) }, 200)
          }
        }
      }
    }
  }
</script>
